import { createGetDownloadPath } from "~/utils/api/reportUtils";

export const getDownloadPath = createGetDownloadPath(
	"/api/vendors/deals/:deal_id/deal_completion_reports"
);
